module.exports = __webpack_public_path__ + "img/图片3.003dfc82.png";